import {
  mdiHomeOutline,
  mdiHistory,
  mdiAccountOutline,
  mdiCurrencyUsd,
  mdiPackageVariantClosed,
  mdiMapMarkerPath,
  mdiNoteTextOutline,
  mdiWalletOutline
} from "@mdi/js";
import trip from "@/assets/Trip.svg";

export default [
  {
    title: "Dashboards",
    icon: mdiHomeOutline,
    to: "dashboards",
  },
  // Deprecated by https://ridery-app.atlassian.net/servicedesk/customer/portal/5/SPR-2544
  // {
  //   subheader: "USERS",
  // },
  // {
  //   title: "CorporatePanels",
  //   icon: mdiAccountOutline,
  //   to: "corporatePanels",
  // },
  {
    subheader: "FINANCIAL",
  },
  {
    title: "CreditDistribution",
    icon: mdiWalletOutline,
    to: "creditDistribution",
  },
  {
    title: "CorporateInvoices",
    icon: mdiNoteTextOutline,
    to: "corporateInvoices",
  },
];
